module.exports = __webpack_public_path__ + "static/img/emoji_148.84fe420.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emoji/emoji_148.png
// module id = D4K2
// module chunks = 6